import { useCallback, useState } from 'react';

type UseTaskCompletionParams = Readonly<{
	isCompleted: boolean;
	onCtaClick?: () => Promise<boolean>;
	onCheckboxChange?: () => Promise<void>;
}>;

type UseTaskCompletionReturn = Readonly<{
	isChecked: boolean;
	handleButtonClick: () => Promise<void>;
	handleCheckboxChange: (checked: boolean) => void;
}>;

export function useTaskCompletion({
	isCompleted,
	onCtaClick,
	onCheckboxChange,
}: UseTaskCompletionParams): UseTaskCompletionReturn {
	const [isChecked, setIsChecked] = useState(isCompleted);

	const handleButtonClick = useCallback(async () => {
		if (onCtaClick) {
			const completed = await onCtaClick();
			if (completed) setIsChecked(true);
		} else if (onCheckboxChange) {
			setIsChecked(true);
			await onCheckboxChange();
		}
	}, [onCtaClick, onCheckboxChange]);

	const handleCheckboxChange = useCallback(
		(newValue: boolean) => {
			if (!newValue || !onCheckboxChange) return;
			setIsChecked(true);
			void onCheckboxChange();
		},
		[onCheckboxChange],
	);

	return { isChecked, handleButtonClick, handleCheckboxChange };
}
